import { createSlice } from '@reduxjs/toolkit';

import { ConfigurationState } from './state.interface';

const initialState: ConfigurationState = {
  features: {
    ART_EDIT: false,
    BASE_PLANS: false,
    CHATBOT: false,
    CHATBOT_VOICE_INPUT: false,
    COMPETENCIES: false,
    COMPETENCIES2: false,
  },
  app: {
    version: '',
  },
  env: {
    API_HOST: '',
  },
  loading: false,
};

export const configuration = createSlice({
  name: 'configuration',
  initialState,
  reducers: {
    setConfigurationFromWindow: state => {
      if (window.APP_CONFIG) {
        state.features = window.APP_CONFIG.features;
        state.app = window.APP_CONFIG.app;
        state.env = window.APP_CONFIG.env;
      }
    },
  },
});

export const { setConfigurationFromWindow } = configuration.actions;
export default configuration;
